module.exports = __webpack_public_path__ + "static/media/remily-logo.a721f827.svg";